var map = {
	"./--logo.png": 614,
	"./-logo.png": 615,
	"./1.png": 1369,
	"./2.png": 1370,
	"./4.png": 1371,
	"./AMPL-logo.png": 616,
	"./AXIOMS-logo.png": 617,
	"./AXMATIC   -logo.png": 618,
	"./AXMATIC  -logo.png": 619,
	"./AXMATIC -logo.png": 620,
	"./AXMATIC-DMAGIC-LP-logo.png": 621,
	"./AXMATIC-DMAGIC-SLP-logo.png": 622,
	"./AXMATIC-DMAGIC-logo.png": 623,
	"./AXMATIC-logo.png": 624,
	"./BAT-logo.png": 625,
	"./BPT-logo.png": 626,
	"./BUSD-logo.png": 627,
	"./Balancer Pool-logo.png": 628,
	"./COMP-logo.png": 629,
	"./CRV-icon.png": 1372,
	"./DAI-logo.png": 630,
	"./DMAGIC     -logo.png": 631,
	"./DMAGIC    -logo.png": 632,
	"./DMAGIC   -logo.png": 633,
	"./DMAGIC  -logo.png": 634,
	"./DMAGIC -logo.png": 635,
	"./DMAGIC-icon.png": 1373,
	"./DMAGIC-logo.png": 636,
	"./DMAGIC-logoold.png": 1374,
	"./DRAX     -logo.png": 637,
	"./DRAX    -logo.png": 638,
	"./DRAX   -logo.png": 639,
	"./DRAX  -logo.png": 640,
	"./DRAX -logo.png": 641,
	"./DRAX-logo.png": 642,
	"./DRAX-logo2.png": 1375,
	"./DRAX-logoolg.png": 1376,
	"./ETH-icon.png": 1377,
	"./ETH-logo.png": 643,
	"./FTM-logo.png": 644,
	"./Governance-logo.png": 645,
	"./HBTC-logo.png": 646,
	"./HUSD-logo.png": 647,
	"./IEARN-icon.png": 1378,
	"./KNC-logo.png": 648,
	"./LEND-logo.png": 649,
	"./LINK-logo.png": 650,
	"./MAGIC-logo.png": 651,
	"./MATIC    -logo.png": 652,
	"./MATIC   -logo.png": 653,
	"./MATIC  -logo.png": 654,
	"./MATIC -logo.png": 655,
	"./MATIC-logo.png": 656,
	"./MEFI-logo.png": 657,
	"./MKR-logo.png": 658,
	"./NEWMBAT-logo.png": 659,
	"./NIGHTBANE    -logo.png": 660,
	"./NIGHTBANE   -logo.png": 661,
	"./NIGHTBANE  -logo.png": 662,
	"./NIGHTBANE -logo.png": 663,
	"./NIGHTBANE-logo.png": 664,
	"./PIP.png": 1379,
	"./REP-logo.png": 665,
	"./SAI-logo.png": 666,
	"./SNX-logo.png": 667,
	"./SUSD-logo.png": 668,
	"./TUSD-logo.png": 669,
	"./USDC-icon.png": 1380,
	"./USDC-logo.png": 670,
	"./USDT-icon.png": 1381,
	"./USDT-logo.png": 671,
	"./WETH-logo.png": 672,
	"./ZRX-logo.png": 673,
	"./aLINK-logo.png": 674,
	"./aave.png": 1382,
	"./arrow.png": 688,
	"./background.png": 1383,
	"./bzx.png": 1384,
	"./cUSDC-logo.png": 675,
	"./cUSDT-logo.png": 676,
	"./choose-logo.png": 677,
	"./compound.png": 1385,
	"./corgiadv.png": 1386,
	"./ddex.png": 1387,
	"./defipulse.png": 1388,
	"./defizap.png": 1389,
	"./dmagic1-logo.png": 678,
	"./ethereum.png": 1390,
	"./etherscan.png": 1391,
	"./fortmaticIcon.png": 1392,
	"./kybernetwork.png": 1393,
	"./ledger.png": 1394,
	"./lendf.png": 1395,
	"./matic-icon.png": 1396,
	"./metamask.png": 1397,
	"./navlogo.png": 1398,
	"./portisIcon.png": 1399,
	"./single-assets/ATOM.png": 1400,
	"./single-assets/BAKE.png": 1401,
	"./single-assets/BDO.png": 1402,
	"./single-assets/BETH.png": 1403,
	"./single-assets/BHC.png": 1404,
	"./single-assets/BIFI.png": 1405,
	"./single-assets/BNB.png": 1406,
	"./single-assets/BNB_nav.png": 1407,
	"./single-assets/BTD.png": 1408,
	"./single-assets/BTS.png": 1409,
	"./single-assets/BURGER.png": 1410,
	"./single-assets/CAKE.png": 1411,
	"./single-assets/CTK.png": 1412,
	"./single-assets/DOT.png": 1413,
	"./single-assets/DRUGS.png": 1414,
	"./single-assets/ETH.png": 1415,
	"./single-assets/HARD.png": 1416,
	"./single-assets/HT.png": 1417,
	"./single-assets/INCH.png": 1418,
	"./single-assets/INJ.png": 1419,
	"./single-assets/JETS.png": 1420,
	"./single-assets/JULD.png": 1421,
	"./single-assets/KEBAB.png": 1422,
	"./single-assets/LINK.png": 1423,
	"./single-assets/MATIC.png": 1424,
	"./single-assets/MATIC2.png": 1425,
	"./single-assets/MATIC_nav.png": 1426,
	"./single-assets/MSC.png": 1427,
	"./single-assets/MSS.png": 1428,
	"./single-assets/NYA.png": 1429,
	"./single-assets/NYAC.png": 1430,
	"./single-assets/NYAS.png": 1431,
	"./single-assets/SBDO.png": 1432,
	"./single-assets/SFP.png": 1433,
	"./single-assets/SMART.png": 1434,
	"./single-assets/SOAK.png": 1435,
	"./single-assets/XTZ.png": 1436,
	"./single-assets/XVS.png": 1437,
	"./single-assets/cakeHARD.png": 1438,
	"./single-assets/cakeROOBEE.png": 1439,
	"./single-assets/cakeSTAX.png": 1440,
	"./single-assets/cakeTWT.png": 1441,
	"./single-assets/cakebROOBEE.png": 1442,
	"./squarelink.png": 1443,
	"./synthetix.png": 1444,
	"./trezor.png": 1445,
	"./truffle.png": 1446,
	"./trustWallet.png": 1447,
	"./undefined-logo.png": 679,
	"./uniswap - Kopie.png": 1448,
	"./uniswap.png": 1449,
	"./vd_cvr.png": 1450,
	"./wBTC-icon.png": 1451,
	"./wBTC-logo.png": 680,
	"./wallets/binance-wallet.png": 594,
	"./wallets/metamask.png": 1452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 687;